export default __webpack_public_path__ + "static/media/Wordpress.7b67fc81.png";